import React from "react";
import Logo from "@/components/Logo";

export default function Footer() {
    return (
        <footer
            className="relative bg-cap-ink text-white py-14 border-t border-white/5"
            data-testid="footer"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
                    <div>
                        <Logo variant="white" />
                        <p className="mt-4 text-white/55 text-[14px] max-w-md leading-relaxed">
                            CapDistrib est une marque commerciale de Flowtex
                            SAS — propulsé par ePaaS.io.
                        </p>
                    </div>
                    <nav className="flex flex-wrap items-center gap-x-7 gap-y-2">
                        <a
                            href="/mentions-legales"
                            className="text-[14px] text-white/70 hover:text-white"
                            data-testid="footer-mentions"
                        >
                            Mentions légales
                        </a>
                        <a
                            href="/confidentialite"
                            className="text-[14px] text-white/70 hover:text-white"
                            data-testid="footer-confidentialite"
                        >
                            Confidentialité
                        </a>
                        <a
                            href="/cgu"
                            className="text-[14px] text-white/70 hover:text-white"
                            data-testid="footer-cgu"
                        >
                            CGU
                        </a>
                        <a
                            href="mailto:contact@capdistrib.com"
                            className="text-[14px] text-white/70 hover:text-white"
                            data-testid="footer-contact"
                        >
                            Contact
                        </a>
                        <a
                            href="/admin"
                            className="text-[13px] text-white/40 hover:text-white/70"
                            data-testid="footer-admin"
                        >
                            Admin
                        </a>
                    </nav>
                </div>
                <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                    <p className="text-[13px] text-white/45">
                        © 2025 Flowtex SAS. Tous droits réservés.
                    </p>
                    <p className="text-[13px] text-white/45">
                        Distribution digitale B2B — France & International
                    </p>
                </div>
            </div>
        </footer>
    );
}
